import { cloneDeep } from "lodash";
import { useState } from "react";

type Dispatcher = {
  open: (val?: any) => void;
  close: () => void;
};

export type DisclosureHost = {
  opened: boolean;
  data?: any;
} & Dispatcher;
/**
 *
 * @param isOpened Initial value that refers state of the dialog
 * @param onOpen A callback function that will be triggered on opening the dialog
 * @param onClose A callback function that is triggered when a particular event or action results in the closure or hiding of a dialog
 * @returns An object with properties and methods to control the disclosure state
 */
const useDisclosure = (
  isOpened?: boolean,
  actions?: { onOpen?: () => void; onClose?: () => void }
): DisclosureHost => {
  const [opened, setOpened] = useState<boolean>(!!isOpened);
  const [data, setData] = useState<any>(undefined);

  function open(data?: any) {
    setData(cloneDeep(data));
    setOpened(true);
    actions?.onOpen?.();
  }

  function close() {
    setOpened(false);
    actions?.onClose?.();
    setData(undefined);
  }

  return { opened, open, close, data };
};

export default useDisclosure;
